import { Reducer } from "redux";

import { PostForgotLinkResponse } from "../models/api/Referral";
import { SendForgotPasswordLinkActionTypes } from "../models/dispatchTypes/User";
import { SendForgotPasswordLinkActionDispatchTypes } from "../constants/User";

const initialState: PostForgotLinkResponse = {
  loading: false,
  response: "",
  error: null,
};

const PostSendPassReducer: Reducer<
PostForgotLinkResponse,
SendForgotPasswordLinkActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case SendForgotPasswordLinkActionDispatchTypes.SEND_FORGOT_PASS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case SendForgotPasswordLinkActionDispatchTypes.SEND_FORGOT_PASS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case SendForgotPasswordLinkActionDispatchTypes.SEND_FORGOT_PASS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case SendForgotPasswordLinkActionDispatchTypes.SEND_FORGOT_PASS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PostSendPassReducer;
